import { ParamsModel } from 'src/app/modules/common/Model'
import { ReportMenuModel } from '../Model'
import { actionTypes } from './constants'

export const actions = {
  getReportMenuData: (params: ParamsModel = { page: 1, limit: 10 }) => ({
    type: actionTypes.GET_REPORT_MENU_START,
    payload: params,
  }),
  getReportMenuDataSuccess: (data: any) => ({
    type: actionTypes.GET_REPORT_MENU_SUCCESS,
    payload: data,
  }),
  getReportMenuDataFinish: () => ({
    type: actionTypes.GET_REPORT_MENU_FINISH,
  }),

  addReportMenu: (data: ReportMenuModel) => ({
    type: actionTypes.ADD_REPORT_MENU_START,
    payload: data,
  }),
  addReportMenuSuccess: (data: any) => ({
    type: actionTypes.ADD_REPORT_MENU_SUCCESS,
    payload: data,
  }),
  addReportMenuFinish: () => ({
    type: actionTypes.ADD_REPORT_MENU_FINISH,
  }),
  resetReportMenu: () => ({
    type: actionTypes.RESET_REPORT_MENU,
  }),

  updateReportMenu: (data: ReportMenuModel, id: string) => ({
    type: actionTypes.UPDATE_REPORT_MENU_START,
    payload: data,
    id,
  }),
  updateReportMenuSuccess: (data: any) => ({
    type: actionTypes.UPDATE_REPORT_MENU_SUCCESS,
    payload: data,
  }),
  updateReportMenuFinish: () => ({
    type: actionTypes.UPDATE_REPORT_MENU_FINISH,
  }),

  deleteReportMenu: (ids: string[]) => ({
    type: actionTypes.DELETE_REPORT_MENU_START,
    payload: ids,
  }),
  deleteReportMenuSuccess: (data: any) => ({
    type: actionTypes.DELETE_REPORT_MENU_SUCCESS,
    payload: data,
  }),
  deleteReportMenuFinish: () => ({
    type: actionTypes.DELETE_REPORT_MENU_FINISH,
  }),

  singleEnableReportMenu: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_REPORT_MENU_REQUEST,
    payload: { data },
  }),
  singleEnableReportMenuSuccess: (id: string) => ({
    type: actionTypes.SINGLE_ENABLE_REPORT_MENU_SUCCESS,
    payload: { id },
  }),
  singleEnableReportMenuFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_REPORT_MENU_FINISH,
  }),

  singleDisableReportMenu: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_REPORT_MENU_REQUEST,
    payload: { data },
  }),
  singleDisableReportMenuSuccess: (id: string) => ({
    type: actionTypes.SINGLE_DISABLE_REPORT_MENU_SUCCESS,
    payload: { id },
  }),
  singleDisableReportMenuFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_REPORT_MENU_FINISH,
  }),

  enableReportMenu: (data: any) => ({
    type: actionTypes.ENABLE_REPORT_MENU_REQUEST,
    payload: { data },
  }),
  enableReportMenuSuccess: (data: any) => ({
    type: actionTypes.ENABLE_REPORT_MENU_SUCCESS,
    payload: data,
  }),
  enableReportMenuFinish: () => ({
    type: actionTypes.ENABLE_REPORT_MENU_FINISH,
  }),

  disableReportMenu: (data: any) => ({
    type: actionTypes.DISABLE_REPORT_MENU_REQUEST,
    payload: { data },
  }),
  disableReportMenuSuccess: (data: any) => ({
    type: actionTypes.DISABLE_REPORT_MENU_SUCCESS,
    payload: data,
  }),
  disableReportMenuFinish: () => ({
    type: actionTypes.DISABLE_REPORT_MENU_FINISH,
  }),
}
